module.exports = __webpack_public_path__ + "img/1.3c388086.png";